var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGreenCheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 72,
    viewBox: "0 0 73 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M36.5 72C56.3822 72 72.5 55.8823 72.5 36C72.5 16.1178 56.3822 0 36.5 0C16.6177 0 0.5 16.1178 0.5 36C0.5 55.8823 16.6177 72 36.5 72Z",
    fill: "#6FCF97"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0241 21.3911H29.7938C28.4245 21.3911 27.3145 22.5011 27.3145 23.8704V23.8704C27.3145 25.2397 28.4245 26.3498 29.7938 26.3498H48.0241C49.3934 26.3498 50.5035 25.2397 50.5035 23.8704C50.5035 22.5011 49.3934 21.3911 48.0241 21.3911Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0174 31.3087H59.8016C61.1709 31.3087 62.2809 32.4188 62.2809 33.7881C62.2809 35.1574 61.1709 36.2674 59.8016 36.2674H18.0174C16.6481 36.2674 15.5381 35.1574 15.5381 33.7881C15.5381 32.4188 16.6481 31.3087 18.0174 31.3087Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0174 41.2262H59.8016C61.1709 41.2262 62.2809 42.3362 62.2809 43.7055C62.2809 45.0749 61.1709 46.1849 59.8016 46.1849H18.0174C16.6481 46.1849 15.5381 45.0749 15.5381 43.7055C15.5381 42.3362 16.6481 41.2262 18.0174 41.2262Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6432 35.4395C23.6148 35.4404 23.5864 35.441 23.558 35.4418C23.5458 35.4734 23.5327 35.5047 23.5176 35.5354L23.6432 35.4395V35.4395Z",
    fill: "#404040"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5812 38.2466C65.8632 22.7562 54.345 9.15945 38.8546 7.87742C23.3642 6.59539 9.7674 18.1136 8.48538 33.604C7.20335 49.0944 18.7215 62.6912 34.212 63.9732C49.7024 65.2553 63.2992 53.7371 64.5812 38.2466Z",
    fill: "#6FCF97"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3346 26L32.0013 44.3333L23.668 36",
    stroke: "white",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenCheck);
export default __webpack_public_path__ + "static/media/greenCheck.4cc2e06e9a9d8ec97ad0371c3ee45d70.svg";
export { ForwardRef as ReactComponent };